
import React, { useState, useRef, useContext, useEffect } from 'react';
import { Transition } from 'react-transition-group';

import { SCAN_SDK_LIST, getScanSdk, saveScanSdk } from '../../scanSdk/scanSdkSetting';
import { CAMERA_RESOLUTION_LIST, getCameraResolution, saveCameraResolution, isCameraResolutionFixed } from '../../scanSdk/cameraResolutionSetting';
import { CAMERA_FOCUS_LIST, getCameraFocus, saveCameraFocus, isCameraFocusFixed, getCameraFocusLabel } from '../../scanSdk/cameraFocusSetting';

import styles from '../../styles/Policy.module.scss'

//OKのSEが鳴り終わるまでの待ち（リロードで音が切れるのを防ぐ
const RELOAD_DELAY = 400;

export function Setting(props) {

//選択中のScanSDK（OK押下まで確定しない
const [selectedSdk, setSelectedSdk] = useState(() => (props.scanSdk ? props.scanSdk : getScanSdk()));
//選択中のカメラ解像度（OK押下まで確定しない
const [selectedResolution, setSelectedResolution] = useState(() => getCameraResolution());
//選択中のカメラフォーカス（OK押下まで確定しない
const [selectedFocus, setSelectedFocus] = useState(() => getCameraFocus());

useEffect(() => {
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');

	document.body.classList.add('is_scroll');
	return () => {
		document.body.classList.remove('is_scroll');
	};
}, []);

//ラジオ選択：ScanSDK
const onSelect = (sdkName) => {
	setSelectedSdk(sdkName);
	//OKボタンと同じSE
	props.setSoundState("se08_se");
}

//ラジオ選択：カメラ解像度
const onSelectResolution = (resolution) => {
	setSelectedResolution(resolution);
	props.setSoundState("se08_se");
}

//ラジオ選択：カメラフォーカス
const onSelectFocus = (focus) => {
	setSelectedFocus(focus);
	props.setSoundState("se08_se");
}

//設定を確定
const onSubmit = () => {
	console.log("【ScanSDK設定】 scanSdk: " + selectedSdk);
	console.log("【ScanSDK設定】 cameraResolution: " + selectedResolution);
	console.log("【ScanSDK設定】 cameraFocus: " + selectedFocus);
	//localStorageへ保存
	saveScanSdk(selectedSdk);
	saveCameraResolution(selectedResolution);
	saveCameraFocus(selectedFocus);
	props.setSoundState("se08_se");

	//設定を切り替えたらリロードして最初からやり直す。
	//※SDKの初期化・カメラ起動はアプリ起動時に一度だけ行う作りのため、
	//　画面遷移で戻るだけでは切り替え後のSDKに入れ替わらない
	//※すぐリロードするとOKのSEが途中で切れるため、鳴らしてから少し待つ
	//　（Modal.jsx の closeModal と同じ考え方）
	setTimeout(reloadForScanSdk, RELOAD_DELAY);
}

//----------------------------------------
//リロード（ScanSDK切替の反映
//----------------------------------------
// timestamp（time）以外のURLパラメータは保持する。

const reloadForScanSdk = () => {
	try {
		const url = new URL(window.location.href);

		//timestamp は外す。
		//※App.js の初期化は「time が無ければ付け直してリダイレクト」する作りなので、
		//　外しておくとアプリ起動直後とまったく同じ経路を通る
		url.searchParams.delete("time");

		//?scan= が付いている場合は選択したSDKへ更新する。
		//※getScanSdk() はURLパラメータをlocalStorageより優先するため、
		//　古い値を残したままにすると今回の選択が上書きされてしまう
		if (url.searchParams.has("scan")) {
			url.searchParams.set("scan", selectedSdk);
		}
		//?res= も同じ理由で更新する
		if (url.searchParams.has("res")) {
			url.searchParams.set("res", selectedResolution);
		}
		//?focus= も同じ理由で更新する
		if (url.searchParams.has("focus")) {
			url.searchParams.set("focus", selectedFocus);
		}

		console.log("【ScanSDK設定】 reload: " + url.href);
		window.location.href = url.href;
	} catch (e) {
		console.log("【ScanSDK設定】 reload error: " + e);
		window.location.reload();
	}
}

return (
	<>

	<div className={styles.policyBlock}>
		<div className={styles.policyBox}>

			<h2 className={styles.policyBox_title}>ScanSDK</h2>
			<p className={styles.policy_txt}>利用するScanSDKを選択してください。</p>

			<div className={styles.radioBox}>
				{SCAN_SDK_LIST.map((sdkName) => (
					<React.Fragment key={sdkName}>
						<input
							type="radio"
							name="scanSdk"
							id={`scanSdk_${sdkName}`}
							value={sdkName}
							checked={selectedSdk === sdkName}
							onChange={() => onSelect(sdkName)}
						/>
						<label htmlFor={`scanSdk_${sdkName}`}>{sdkName}</label>
					</React.Fragment>
				))}
			</div>

			{/* カメラ解像度：本番はenvで固定のため非表示 */}
			{isCameraResolutionFixed() ? null : (
				<>
				<h2 className={styles.policyBox_title}>カメラ解像度</h2>
				<p className={styles.policy_txt}>利用するカメラ解像度を選択してください。</p>

				<div className={styles.radioBox}>
					{CAMERA_RESOLUTION_LIST.map((resolution) => (
						<React.Fragment key={resolution}>
							<input
								type="radio"
								name="cameraResolution"
								id={`cameraResolution_${resolution}`}
								value={resolution}
								checked={selectedResolution === resolution}
								onChange={() => onSelectResolution(resolution)}
							/>
							<label htmlFor={`cameraResolution_${resolution}`}>{resolution}</label>
						</React.Fragment>
					))}
				</div>
				</>
			)}

			{/* カメラフォーカス：本番はenvで固定のため非表示 */}
			{/* ※NEAR は単焦点固定（focusDistance を最も近い側へ寄せる） */}
			{isCameraFocusFixed() ? null : (
				<>
				<h2 className={styles.policyBox_title}>カメラフォーカス</h2>
				<p className={styles.policy_txt}>AUTO以外は単焦点に固定します。数値はピントを合わせる距離（メートル）です（barkoder / scanbot のみ）。</p>

				<div className={styles.radioBox}>
					{CAMERA_FOCUS_LIST.map((focus) => (
						<React.Fragment key={focus}>
							<input
								type="radio"
								name="cameraFocus"
								id={`cameraFocus_${focus}`}
								value={focus}
								checked={selectedFocus === focus}
								onChange={() => onSelectFocus(focus)}
							/>
							<label htmlFor={`cameraFocus_${focus}`}>{getCameraFocusLabel(focus)}</label>
						</React.Fragment>
					))}
				</div>
				</>
			)}

			<button className="modalBtn modalBtn01" onClick={onSubmit}><span>OK</span></button>
		</div>

	</div>

	</>
)
}
